import { createSlice } from '@reduxjs/toolkit'

export function getPreferredColorMode() {
  try {
    const savedMode = window.localStorage.getItem('akive-color-mode')
    if (savedMode === 'light' || savedMode === 'dark') return savedMode
  } catch {
    // 저장소 접근이 제한되면 운영체제 설정을 사용한다.
  }
  return window.matchMedia?.('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
}

const preferencesSlice = createSlice({
  name: 'preferences',
  initialState: { colorMode: getPreferredColorMode() },
  reducers: {
    setColorMode: (state, action) => {
      state.colorMode = action.payload
    },
    toggleColorMode: (state) => {
      state.colorMode = state.colorMode === 'dark' ? 'light' : 'dark'
    },
  },
})

export const { setColorMode, toggleColorMode } = preferencesSlice.actions
export const selectColorMode = (state) => state.preferences.colorMode
export default preferencesSlice.reducer
